import { useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { getHalfYearlySubscribers } from 'features/statement/statementActions';
import {
  selectHalfYearlySubscribers,
  selectStatementLoading,
} from 'features/statement/statementSlice';
import MuiTable from 'modules/billing/components/muiTable/MuiTable';
import {
  MonthColor,
  MonthTitle,
  MonthView,
  MonthWrapper,
} from 'modules/billing/pages/comparison/charts/Charts.styles';
import { Cell, Label, Pie, PieChart, ResponsiveContainer } from 'recharts';

import {
  Title,
  ViewContainer,
} from '../../../modules/billing/pages/subscribers/Subscribers.styles';
import { ChatRow } from '../PaymentReport/PaymentReportFilters/PaymentReportFilters.styles';
import SubscribersFilters from './SubscribersFilters';
import { FilterContainerSubscribers } from './SubscribersFilters/SubscribersFilters.styles';
import { useSubscribersSearchParams } from './useSubscribersSearchParams';

const Subscribers = () => {
  const { searchData: subscribersSearchData, setSubscribersSearchData } =
    useSubscribersSearchParams();

  const handlePageChange = (page) => {
    setSubscribersSearchData({ page: page - 1 });
  };

  const data = useSelector(selectHalfYearlySubscribers);
  const loading = useSelector(selectStatementLoading);
  const dispatch = useDispatch();

  const columns = [
    { id: 'year', label: 'Տարի' },
    {
      id: 'halfYear',
      label: 'Կիսամյակ',
    },
    { id: 'internet', label: 'Համացանց' },
    { id: 'tv', label: 'TV' },
    { id: 'domophone', label: 'Դոմոֆոն' },
    { id: 'total', label: 'Ընդհանուր' },
  ];

  const formattedTotal = data.totalAmount?.toLocaleString('hy-AM');
  const pieData = [
    { name: 'Դոմոֆոն', value: data.totalDomophone || 0, color: '#2D6CDF' },
    { name: 'Համացանց', value: data.totalInternet || 0, color: '#FF6A00' },
    { name: 'TV', value: data.totalTv || 0, color: '#00C853' },
  ];

  const hasAllFilters =
    subscribersSearchData.fromYear !== '' && subscribersSearchData.toYear !== '';
  useEffect(() => {
    dispatch(getHalfYearlySubscribers(subscribersSearchData));
  }, [subscribersSearchData, dispatch]);

  return (
    <>
      <ViewContainer>
        <SubscribersFilters />
        {hasAllFilters && (
          <FilterContainerSubscribers>
            {!loading.halfYearlySubscribers && (
              <Title className="inline_title ">
                Ընդհանուր բաժանորդների քանակը՝ {''}
                {Number(data.totalAmount).toLocaleString('hy-AM')}
              </Title>
            )}
          </FilterContainerSubscribers>
        )}
        {hasAllFilters && (
          <ChatRow>
            <div style={{ width: '650px', height: 'auto' }}>
              <ResponsiveContainer width="100%" height={300}>
                <PieChart>
                  <Pie
                    data={pieData}
                    dataKey="value"
                    nameKey="name"
                    innerRadius={80}
                    outerRadius={130}
                    fill="#8884d8"
                    label={({ value, cx, cy, midAngle, innerRadius, outerRadius }) => {
                      const RADIAN = Math.PI / 180;
                      const radius = outerRadius + 25;
                      const x = cx + radius * Math.cos(-midAngle * RADIAN);
                      const y = cy + radius * Math.sin(-midAngle * RADIAN);

                      const formattedValue = value?.toLocaleString('hy-AM');

                      return (
                        <text
                          x={x}
                          y={y}
                          fill="#333"
                          textAnchor={x > cx ? 'start' : 'end'}
                          dominantBaseline="central"
                          fontSize={13}
                          fontWeight="700"
                        >
                          {formattedValue}
                        </text>
                      );
                    }}
                  >
                    {pieData.map((entry, index) => (
                      <Cell key={`cell-${index}`} fill={entry.color} />
                    ))}
                    <Label
                      value={formattedTotal}
                      position="center"
                      fontSize={16}
                      fontWeight="600"
                      fill="#6C757D"
                    />
                  </Pie>
                </PieChart>
              </ResponsiveContainer>
            </div>
            <MonthWrapper>
              <MonthView>
                <MonthColor />
                <MonthTitle>Համացանց</MonthTitle>
              </MonthView>
              <MonthView>
                <MonthColor $isNext={true} />
                <MonthTitle>Դոմոֆոն</MonthTitle>
              </MonthView>
              <MonthView>
                <MonthColor style={{ background: '#00C853' }} />
                <MonthTitle>TV</MonthTitle>
              </MonthView>
            </MonthWrapper>
          </ChatRow>
        )}
        <MuiTable
          rowCount={subscribersSearchData.size}
          data={data?.data || []}
          loading={loading.halfYearlySubscribers}
          columns={columns}
          showPagination={false}
          handlePageChange={handlePageChange}
        />
      </ViewContainer>
    </>
  );
};

export default Subscribers;
